import classNames from 'classnames';
import { FC } from 'react';

interface Props {
  labels: { label: string }[];
  activeTabIndex: number;
  onTabChange?: (index: number) => void;
}

export const DonorDetailTabs: FC<Props> = ({ labels, activeTabIndex, onTabChange }) => {
  return (
    <div className="date-filter-container">
      {labels.map((option, index) => (
        <button
          key={option.label}
          className={classNames('date-filter-item', { active: activeTabIndex === index })}
          onClick={() => onTabChange && onTabChange(index)}
          type="button"
        >
          <span className="oath-body inkBlue">{option.label}</span>
        </button>
      ))}
    </div>
  );
};
